function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 350.87,
    y1: 369.13,
    x2: 442.17,
    y2: 277.83,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570 204.78 496.96 277.83 442.17 277.83 442.17 223.04 515.22 150 515.22 204.78 570 204.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.74,369.13C551.74,480.07,461.81,570,350.87,570S150,480.07,150,369.13s89.93-200.87,200.87-200.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,290.94A200.71,200.71,0,1,1,429.06,184.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.41,330A100.34,100.34,0,1,1,390,276.59",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.f7c8c3e1a2c1e1397aeba29100dacc2a.svg";
export { ForwardRef as ReactComponent };